import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import WhereToVote from '@material-ui/icons/WhereToVote';
import LocalPhone from '@material-ui/icons/LocalPhone';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import './Review.css';

const style = (theme) => ({
  infoArea: {
    maxWidth: '460px',

    marginLeft: '300px',
    // margin: "0 auto",
    padding: '0px',
    textAlign: 'center',
  },
  infoArea2: {
    maxWidth: '460px',
    marginRight: '200px',

    // margin: "0 auto",
    padding: '0px',
    textAlign: 'center',
  },
  iconWrapper: {
    float: 'left',
    marginTop: '24px',
    marginRight: '10px',
  },
  success: {
    color: '#4caf50',
  },
  icon: {
    width: '36px',
    height: '36px',
  },
  descriptionWrapper: {
    // color: grayColor,
    overflow: 'hidden',
  },
  title: {
    color: '#3C4858',
    margin: '1.75rem 0 0.875rem !important',
    marginTop: '30px',
    minHeight: 'unset',
    // font-family: "Roboto Slab", "Times New Roman", serif;
    fontWeight: 700,
    marginBottom: '25px',
    textDecoration: 'none',
  },
  description: {
    // color: grayColor,
    overflow: 'hidden',
    marginTop: '0px',
    fontSize: '14px',
  },
  iconWrapperVertical: {
    float: 'none',
  },
  iconVertical: {
    width: '61px',
    height: '61px',
  },
  button: {
    marginLeft: '100px',
  },
  infoSection: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  infoConteyner: {
    borderRadius: '30px',
    background: '#FFF',
    boxShadow: '0px 0px 10px 0px rgba(49, 40, 63, 0.10)',
    width: '45%',
    padding: '5px 15px 35px',
    textAlign: 'left',
    overflow: 'hidden',
    maxHeight: '342px',
    position: 'relative',
    margin: '15px 0',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  infoTitle: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#0A0A13',
    whitespace: 'nowrap',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '130%',
  },
  infoDescription: {
    overflow: 'hidden',
    color: '#0A0A13',
    textOverflow: 'ellipsis',
    whitespace: 'nowrap',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '130%',
  },
});

class ResortLocation extends Component {
  state = {
    resortName: '',
    resortIndex: '',
    resortRegion: '',
    resortDistrict: '',
    resortCity: '',
    resortStreet: '',
    resortAppartament: '',
    resortTel: '',
    resortMobTel: '',
    resortFax: '',
    resortWeb: '',
    resortEmail: '',
  };

  static getDerivedStateFromProps(props, state) {
    return {
      resortName: props.mapMo.P_3,
      resortIndex: props.mapMo.P_4,
      resortRegion: props.mapMo.P_5,
      resortDistrict: props.mapMo.P_6,
      resortCity: props.mapMo.P_7,
      resortStreet: props.mapMo.P_8,
      resortAppartament: props.mapMo.P_9,
      resortTel: props.mapMo.P_10,
      resortMobTel: props.mapMo.P_11,
      resortFax: props.mapMo.P_12,
      resortWeb: props.mapMo.P_13,
      resortEmail: props.mapMo.P_14,
    };
  }

  render() {
    const { classes } = this.props;

    const iconWrapper = classNames({
      [classes.iconWrapper]: true,
      [classes.success]: true,
      [classes.iconWrapperVertical]: true,
    });
    const iconClasses = classNames({
      [classes.icon]: true,
      [classes.iconVertical]: true,
    });
    return (
      <div className="container-fluid resorLocation mt-2">

<div className={classes.infoSection}>        
<div className={classes.infoConteyner}>
    <p ref={this.textRef} className={classes.title}>Адреса закладу</p>
    <p className={classes.infoTitle}>Індекс:<span className={classes.infoDescription}>{this.state.resortIndex}</span></p>
    <p className={classes.infoTitle}>Область: <span className={classes.infoDescription}>{this.state.resortRegion}</span> </p>
    <p className={classes.infoTitle}>Район: <span className={classes.infoDescription}>{this.state.resortDistrict}</span> </p>
    <p className={classes.infoTitle}>Населений пункт: <span className={classes.infoDescription}>{this.state.resortCity}</span> </p>
    <p className={classes.infoTitle}>Вулиця: <span className={classes.infoDescription}>{this.state.resortStreet}</span> </p>
    <p className={classes.infoTitle}>Номер будинку: <span className={classes.infoDescription}>{this.state.resortAppartament}</span> </p>
</div>

<div className={classes.infoConteyner}>
    <p ref={this.textRef} className={classes.title}>Контакти закладу</p>
    <p className={classes.infoTitle}>Стаціонарний номер телефону:<span className={classes.infoDescription}>{this.state.resortTel}</span></p>
    <p className={classes.infoTitle}>Мобільний номер телефону: <span className={classes.infoDescription}>{this.state.resortMobTel}</span> </p>
    <p className={classes.infoTitle}>Номер телефаксу: <span className={classes.infoDescription}>{this.state.resortFax}</span> </p>
    <p className={classes.infoTitle}>Адреса веб-сайту: <span className={classes.infoDescription}>{this.state.resortWeb}</span> </p>
    <p className={classes.infoTitle}>Адреса електронної пошти: <span className={classes.infoDescription}>{this.state.resortEmail}</span> </p>
</div>
</div>










        <Grid container spacing={2}>
          {/* <Grid justifyContent="center" item xs={12} sm={12} md={6}>
            <div className={classes.infoArea}>
              <div className={iconWrapper}>
                <WhereToVote className={iconClasses} />
              </div>
              <div className={classes.descriptionWrapper}>
                <h4 className={classes.title}>Адреса закладу</h4>
                <span className={classes.title}>Індекс: </span>
                <span className={classes.description}>
                  {this.state.resortIndex}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Область: </span>
                <span className={classes.description}>
                  {this.state.resortRegion}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Район: </span>
                <span className={classes.description}>
                  {this.state.resortDistrict}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Населений пункт: </span>
                <span className={classes.description}>
                  {this.state.resortCity}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Вулиця: </span>
                <span className={classes.description}>
                  {this.state.resortStreet}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Номер будинку: </span>
                <span className={classes.description}>
                  {this.state.resortAppartament}
                  {' '}
                </span>
              </div>
            </div>
          </Grid> */}

          {/* <Grid justify="center" item xs={12} sm={12} md={6}>
            <div className={classes.infoArea2}>
              <div className={iconWrapper}>
                <LocalPhone className={iconClasses} />
              </div>
              <div className={classes.descriptionWrapper}>
                <h4 className={classes.title}>Контакти закладу</h4>
                <span className={classes.title}>
                  Стаціонарний номер телефону:
                  {' '}
                </span>
                <span className={classes.description}>
                  {this.state.resortTel}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>
                  Мобільний номер телефону:
                  {' '}
                </span>
                <span className={classes.description}>
                  {this.state.resortMobTel}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Номер телефаксу: </span>
                <span className={classes.description}>
                  {this.state.resortFax}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>Адреса веб-сайту: </span>
                <span className={classes.description}>
                  {this.state.resortWeb}
                  {' '}
                </span>
              </div>
              <div className={classes.descriptionWrapper}>
                <span className={classes.title}>
                  Адреса електронної пошти:
                  {' '}
                </span>
                <span className={classes.description}>
                  {this.state.resortEmail}
                  {' '}
                </span>
              </div>
            </div>
          </Grid> */}
        </Grid>

        {/* <div className="row smallText">
          <div className="col-12">
            <hr />
          </div> */}

          {/* <div className="col-12" style={{ marginLeft: '280px' }}>
            <NavLink
              to="/mop/search"
              style={{ textDecoration: 'none' }}
              activeStyle={{
                border: '1px solid #fff',
              }}
            >
              <span
                className="btn btn-primary btn-md btn-search mb-3"
                role="button"
              >
                Назад до пошуку
              </span>
            </NavLink>
          </div> */}
        {/* </div> */}
      </div>
    );
  }
}

ResortLocation.propTypes = {};
export default withStyles(style)(ResortLocation);
